import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { getDatabase, ref, onValue, set } from 'firebase/database';
import { getAuth } from 'firebase/auth';
import { onAuthStateChanged } from 'firebase/auth';
import { signInWithCustomToken } from 'firebase/auth';
import './profil.css';

const Profil = (props) => {

  const userId = props.match.params.userId;
  const [userData, setUserData] = useState(null);
  const [question1, setQuestion1] = useState('');
  const [question2, setQuestion2] = useState('');
  const [question3, setQuestion3] = useState('');
  const [question4, setQuestion4] = useState('');
  const [savePopup, setSavePopup] = useState(false);
  const [saveButton, setSaveButton] = useState(false);

  console.log("userId:", userId); // Log the userId

  useEffect(() => {
    const auth = getAuth();
  
    // Retrieve the custom token from the URL
    const urlParams = new URLSearchParams(window.location.search);
    const customToken = urlParams.get('token');
  
    if (customToken) {
      console.log('Custom token found:', customToken);
  
      // Sign in with the custom token
      signInWithCustomToken(auth, customToken)
        .then((userCredential) => {
          // Signed in
          var user = userCredential.user;
          console.log('Signed in with custom token:', user);
          // fetch user data here
        })
        .catch((error) => {
          var errorCode = error.code;
          var errorMessage = error.message;
          console.error('Error signing in with custom token:', errorCode, errorMessage);
        });
    } else {
      console.log('No custom token found.');
    }
  
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        console.log("User is authenticated, fetching data...");
        const db = getDatabase();
        const userRef = ref(db, 'users/' + userId);
  
        console.log("Fetching user data..."); // Log before fetching data
  
        onValue(userRef, (snapshot) => {
          const data = snapshot.val();
          console.log("Fetched user data:", data); // Log the fetched data
          setUserData(data);

          // If the fetched user data includes answers to the questions, set the state of the questions accordingly
          if (data.questions) {
            setQuestion1(data.questions.question1 || '');
            setQuestion2(data.questions.question2 || '');
            setQuestion3(data.questions.question3 || '');
            setQuestion4(data.questions.question4 || '');
          }
        }, (error) => {
          console.error("Error fetching user data:", error); // Log any errors
        });
      } else {
        console.log("User is not authenticated, cannot fetch data.");
      }
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, [userId]);

  const saveAnswers = async () => {
      console.log('saveAnswers function called');
      const db = getDatabase();
      const userRef = ref(db, 'users/' + userId);
      await set(userRef, {
        ...userData,
        questions: {
          question1,
          question2,
          question3,
          question4
        }
      });
      setSaveButton(true);
      setTimeout(() => setSaveButton(false), 2000);
  }
  
     
  console.log("Rendering... userData:", userData); // Log before rendering
  
    if (!userData) {
      return <div>Loading 🫡...</div>;
    }

    console.log("userData:", userData); // Debugging line

    // Now, here you need to return your JSX, with the additional code added for the questions, the save button, and the save popup.
    // However, since your original code snippet ends here, I'm unable to include this in the updated code.


  return (
    <>
      {userData && (
            <div className="profil-container">
              <Helmet>
              <title>Profil - {userData.firstName}</title>
              <meta property="og:title" content={`Profil -  ${userData.firstName}`} />
              </Helmet>
              <div data-modal="practices" className="profil-modal">
                <div className="profil-practices">
                  <div className="profil-heading">
                    <span className="profil-header">Our practices</span>
                    <svg
                      viewBox="0 0 1024 1024"
                      data-close="practices"
                      className="profil-close"
                    >
                      <path d="M225.835 286.165l225.835 225.835-225.835 225.835c-16.683 16.683-16.683 43.691 0 60.331s43.691 16.683 60.331 0l225.835-225.835 225.835 225.835c16.683 16.683 43.691 16.683 60.331 0s16.683-43.691 0-60.331l-225.835-225.835 225.835-225.835c16.683-16.683 16.683-43.691 0-60.331s-43.691-16.683-60.331 0l-225.835 225.835-225.835-225.835c-16.683-16.683-43.691-16.683-60.331 0s-16.683 43.691 0 60.331z"></path>
                    </svg>
                  </div>
                  <div className="profil-grid">
                    <div className="profil-section">
                      <div className="profil-heading1">
                        <span className="profil-header01">Cardiology</span>
                        <span className="profil-caption">
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                          do eiusmod tempor incididunt.
                        </span>
                      </div>
                      <div className="read-more">
                        <span className="profil-text">Read more</span>
                        <img
                          alt="image"
                          src="/Icons/arrow-2.svg"
                          className="profil-image"
                        />
                      </div>
                    </div>
                    <div className="profil-section1">
                      <div className="profil-heading2">
                        <span className="profil-header02">Orthopedics</span>
                        <span className="profil-caption01">
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                          do eiusmod tempor incididunt.
                        </span>
                      </div>
                      <div className="read-more">
                        <span className="profil-text01">Read more</span>
                        <img
                          alt="image"
                          src="/Icons/arrow-2.svg"
                          className="profil-image01"
                        />
                      </div>
                    </div>
                    <div className="profil-section2">
                      <div className="profil-heading3">
                        <span className="profil-header03">Ophtalmology</span>
                        <span className="profil-caption02">
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                          do eiusmod tempor incididunt.
                        </span>
                      </div>
                      <div className="read-more">
                        <span className="profil-text02">Read more</span>
                        <img
                          alt="image"
                          src="/Icons/arrow-2.svg"
                          className="profil-image02"
                        />
                      </div>
                    </div>
                    <div className="profil-section3">
                      <div className="profil-heading4">
                        <span className="profil-header04">Pediatrics</span>
                        <span className="profil-caption03">
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                          do eiusmod tempor incididunt.
                        </span>
                      </div>
                      <div className="read-more">
                        <span className="profil-text03">Read more</span>
                        <img
                          alt="image"
                          src="/Icons/arrow-2.svg"
                          className="profil-image03"
                        />
                      </div>
                    </div>
                    <div className="profil-section4">
                      <div className="profil-heading5">
                        <span className="profil-header05">Nutrition</span>
                        <span className="profil-caption04">
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                          do eiusmod tempor incididunt.
                        </span>
                      </div>
                      <div className="read-more">
                        <span className="profil-text04">Read more</span>
                        <img
                          alt="image"
                          src="/Icons/arrow-2.svg"
                          className="profil-image04"
                        />
                      </div>
                    </div>
                    <div className="profil-section5">
                      <div className="profil-heading6">
                        <span className="profil-header06">General</span>
                        <span className="profil-caption05">
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                          do eiusmod tempor incididunt.
                        </span>
                      </div>
                      <div className="read-more">
                        <span className="profil-text05">Read more</span>
                        <img
                          alt="image"
                          src="/Icons/arrow-2.svg"
                          className="profil-image05"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <section className="profil-hero">
                <header data-thq="thq-navbar" className="profil-navbar">
                  <div className="profil-left">
                    <img
                      alt="image"
                      src="/untitled%20design-1500h.png"
                      className="profil-image06"
                    />
                    <nav className="profil-links">
                      <span className="profil-link">How it works</span>
                      <span className="profil-link1">Contact</span>
                    </nav>
                  </div>
                  <div data-thq="thq-navbar-btn-group" className="profil-right">
                    <button className="profil-book button button-main" onClick={saveAnswers}>
                      <span className="profil-text06">Save ✅</span>
                    </button>
                    {saveButton && 
                        <button className="profil-book button button-main">
                          <span className="profil-text06">Saved! ⛳</span>
                        </button>
                      }
                  </div>
                  <div data-thq="thq-burger-menu" className="profil-burger-menu">
                    <svg viewBox="0 0 1024 1024" className="profil-icon1">
                      <path d="M128 554.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 298.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667zM128 810.667h768c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667h-768c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667z"></path>
                    </svg>
                  </div>
                  <div data-thq="thq-mobile-menu" className="profil-mobile-menu">
                    <div
                      data-thq="thq-mobile-menu-nav"
                      data-role="Nav"
                      className="profil-nav"
                    >
                      <div className="profil-container1">
                        <img
                          alt="image"
                          src="/Branding/logo-1500h.png"
                          className="profil-image07"
                        />
                        <div data-thq="thq-close-menu" className="profil-menu-close">
                          <svg viewBox="0 0 1024 1024" className="profil-icon3">
                            <path d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"></path>
                          </svg>
                        </div>
                      </div>
                      <nav
                        data-thq="thq-mobile-menu-nav-links"
                        data-role="Nav"
                        className="profil-nav1"
                      >
                        <span className="profil-text07">Features</span>
                        <span className="profil-text08">How it works</span>
                        <span className="profil-text09">Prices</span>
                        <span className="profil-text10">Contact</span>
                        <button className="profil-book1 button button-main">
                          <img
                            alt="image"
                            src="/Icons/calendar.svg"
                            className="profil-image08"
                          />
                          <span className="profil-text11">Book an appointment</span>
                        </button>
                      </nav>
                    </div>
                  </div>
                </header>
                <div className="profil-main">
                  <div className="profil-content">
                    <h1 className="profil-header07">Hello  {userData.firstName} 🫡 </h1>
                    <div className="profil-heading7">
                      <form className="profil-form">
                        <p className="profil-caption06">
                          Décris comment les gens te voient en tant que personne. 👻
                        </p>
                        <textarea
                          value={question1}
                          onChange={(e) => setQuestion1(e.target.value)}
                          placeholder="placeholder"
                          className="profil-textarea textarea"
                        />
                      </form>
                      <form className="profil-form1">
                        <p className="profil-caption07">
                          Décris quel est le thème de ta chaine Instagram 🚀
                        </p>
                        <textarea
                          value={question2}
                          onChange={(e) => setQuestion2(e.target.value)}
                          placeholder="placeholder"
                          className="profil-textarea1 textarea"
                        />
                      </form>
                      <form className="profil-form2">
                        <p className="profil-caption08">
                          Décris tes habitudes et ce que tu aimes dans la vie ou sur insta 💓
                        </p>
                        <textarea
                          value={question3}
                          onChange={(e) => setQuestion3(e.target.value)}
                          placeholder="placeholder"
                          className="profil-textarea2 textarea"
                        />
                      </form>
                      <form className="profil-form3">
                        <p className="profil-caption09">
                          Décris tes habitudes et ce que tu n&apos;aimes pas dans la vie ou sur insta 👿
                        </p>
                        <textarea
                          value={question4}
                          onChange={(e) => setQuestion4(e.target.value)}
                          placeholder="placeholder"
                          className="profil-textarea3 textarea"
                        />
                      </form>
                    </div>
                  </div>
                  <div className="profil-content1">
                    <div className="profil-heading8"></div>
                  </div>
                </div>
                <div className="profil-background"></div>
              </section>
              <div className="profil-footer">
                <div className="profil-left1">
                  <div className="profil-brand">
                    <img
                      alt="image"
                      src="/untitled%20design%20(1)-200h.png"
                      className="profil-image09"
                    />
                    <p className="profil-text12">
                      Assistgram is a current software web app under development
                    </p>
                  </div>
                  <div className="profil-socials">
                    <div className="social">
                      <img
                        alt="image"
                        src="/Icons/insider.svg"
                        className="profil-image10"
                      />
                    </div>
                    <div className="social">
                      <img
                        alt="image"
                        src="/Icons/instagram.svg"
                        className="profil-image11"
                      />
                    </div>
                    <div className="social">
                      <img
                        alt="image"
                        src="/Icons/twitter.svg"
                        className="profil-image12"
                      />
                    </div>
                  </div>
                  <div className="profil-legal">
                    <span className="profil-copyright">
                      © 2023 Assitgram. All Rights Reserved.
                    </span>
                  </div>
                </div>
                <div className="profil-right1">
                  <div className="profil-list">
                    <span className="profil-header08">Privacy Policy</span>
                  </div>
                  <div className="profil-list1">
                    <span className="profil-header09">Terms of Use</span>
                  </div>
                  <div className="profil-list2">
                    <span className="profil-header10">Contact</span>
                    <div className="profil-links1">
                      <span className="profil-link2">
                        <span className="profil-text13">57 rue Marx Dormoy </span>
                        <br></br>
                        <br></br>
                        <span>87000 Limoges</span>
                        <br></br>
                        <br></br>
                        <span>France</span>
                        <br></br>
                        <br></br>
                      </span>
                      <a
                        href="mailto:contact@template.new?subject=Main"
                        className="profil-link3"
                      >
                        hey.vmartin@gmail.com
                      </a>
                    </div>
                  </div>
                </div>
                <div className="profil-legal1">
                  <div className="profil-row">
                    <span className="legal-link">Privacy Policy</span>
                    <span className="legal-link">Terms of Use</span>
                  </div>
                  <span className="profil-copyright3">
                    © 2022 finbest. All Rights Reserved.
                  </span>
                </div>
              </div>
              <div>
              </div>   
            </div>
      )
      }  
    </>
  
  
  )
}

export default Profil
